import * as Option from "fp-ts/lib/Option";
export function identity(value) {
    return value;
}
export function wait(ms) {
    var start = Date.now();
    var now = start;
    while (now - start < ms) {
        now = Date.now();
    }
}
export function enforceDoubles(value) {
    if (value < 10)
        return "0".concat(value);
    return "".concat(value);
}
export function enforceEmptyOnZero(value) {
    if (value === 0)
        return "";
    return "".concat(value);
}
export function doWhenSome(cb) {
    return function (optional) {
        if (Option.isNone(optional))
            return;
        return cb(optional.value);
    };
}
export function round1000(value) {
    return Math.round(value / 1000) * 1000;
}
export function isObj(blob) {
    return typeof blob === "object" && blob !== null && !Array.isArray(blob);
}
export function urlify(value) {
    return value
        .replace(/[^\w\s]/g, "")
        .replace(/\s+/g, "-")
        .toLowerCase();
}
export function truncate(limit, value) {
    if (limit <= 0)
        return "";
    if (limit >= value.length)
        return value;
    if (isOnLastWord(limit, value))
        return value;
    var index = getIndexAfterEndingWord(limit, value);
    if (index === -1)
        return value;
    return "".concat(value.substring(0, index), " ...");
}
export function isOnLastWord(limit, value) {
    var tail = value.substring(limit - 1, value.length);
    return !tail.trimEnd().includes(" ");
}
export function getIndexAfterEndingWord(limit, value) {
    var tail = value.substring(limit - 1, value.length);
    var tailIndex = tail.indexOf(" ");
    return tailIndex === -1 ? value.length : limit - 1 + tailIndex;
}
export function capitalizeFirstLetter(text) {
    return text.length > 0 ? text.charAt(0).toUpperCase() + text.slice(1) : text;
}
